// perspective: 1px;
// transform-style: preserve-3d;
// 背景
// transform: translateZ(-1) scale(1);


let CN = {
    default: "CN",
    // 展览
    exhibition: {
        title: require("./assets/images/lee_title.svg"),
        // title: "擬遊未盡-<br/><span>李小龍故居</span>復現企劃",
        des: `
        <p>2019 年，九龍塘金巴倫道 41 號被夷為平地，李小龍會與全球龍迷並肩努力爭取了十一年的事終告落空，屬於我們香港的巨星李小龍故居從此灰飛煙滅。</p>
        <p>三年後的今天，我們很高興的向全世界宣佈，「李小龍故居復現企劃」已經展開！</p>
        <p>李小龍會與 <a href="https://www.facebook.com/prizm.digital/">PRIZM Group</a> 携手，同時聯同三位沙田 IVE 學院多媒體學生，以 Web3.0 科技重現李小龍故居「棲鶴小築」，讓全球影迷能親身作客進入巨星之家，透過互動內容讓參觀者得到彷如置身現場的體驗。無論日後身處何地，都可以參與我們或其他內容創作者舉辦的活動；是次企劃，香港理工大學設計學院亦參與提供互動內容建議，並且得到電腦動畫大師馬富強先生作技術顧問。我們預計整個企劃將在明年七月二十日，李小龍生先離世五十週年前夕完成。</p>
        `,
        detailList: {
            title: "展覽資訊",
            date: require("./assets/images/time.svg"),
            location: {
                title: "活動地點",
                txt: "銅鑼灣羅素街 38 號地下 D 舖"
            },
            actTime: {
                title: "開放時間",
                timeList: [
                    { date: ["星期日", "星期四"], time: ["11am", "8pm"] },
                    { date: ["星期五", "星期六"], time: ["11am", "9pm"] },
                ],
            },
            // list: [
            //     {
            //         icon: require("@/assets/images/svg/icon_location.svg"),
            //         title: "地點",
            //         txt: "銅鑼灣羅素街 38 號地下 D 舖",
            //     },
            //     {
            //         icon: require("@/assets/images/svg/icon_date.svg"),
            //         title: "日期",
            //         txt: "2022 年 8 月 6 至  14 日",
            //     },
            // ],
        },
        map: require("./assets/images/image_map.png")
    },
    // VR体验
    VR: {
        title: "故居VR體驗",
        des: "今次建造的 1：1 真實比例虛擬場景帶你重回上世紀 70 年代的九龍塘金巴倫道 41 號。全球的一眾影迷能親身作客進入一代武術巨星之家，以 Web3.0 沉浸式技術 (Immersive Experience) 去體驗李小龍先生的生活細節。",
        bannerList: [
            {
                img: require("@/assets/images/pic1.png"),
                des: "李小龍元宇宙故居院内景色。",
            },
            {
                img: require("@/assets/images/pic2.png"),
                des: "團隊參考大量當年的舊照，著重細節，重現別墅真實面貌。",
            },
            {
                img: require("@/assets/images/pic3.png"),
                des: "棲鶴小築門牌，相傳為國畫大師張大千所書。",
            },
            {
                img: require("@/assets/images/pic6.png"),
                des: "(從左至右) 學生李俊傑、阮浩樺、李振杰，PRIZM Group總監侯晉熙，李小龍會會長黃燿強，香港理工大學周嘉年博士、江培強博士，IVE講師張明然",
            },
            {
                img: require("@/assets/images/pic5.png"),
                des: "李小龍故居的高空拍攝圖 (1973年)",
            },
            {
                img: require("@/assets/images/pic4.png"),
                des: "「棲鶴小築」業權易手後，曾淪落為時鐘酒店。",
            },

        ],
    },
    // 精华
    JH: {
        // title: require("./assets/images/image_title_3.png"),
        title: "展覽精華",
        des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
        bannerList: [
            {
                img: require("@/assets/images/banner2.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner1.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner2.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner1.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
        ],
    },
    // 联络我们
    callUs: {
        // title: "歡迎留低你的聯絡方法",
        des: `立刻登記接收第一手李小龍收藏品資訊，參與優先試玩，<br />懇請密切留意BruceLeeVerse的最新動向。 
        <br /><br />我們將於不久將來和大家於李小龍虛擬故居見面！`,
        form: {
            name: {
                title: "你的名稱",
                zw: ["姓氏", "名字"],
            },
            country: {
                title: "你的國家/地區",
                zw: "國家/地區",
            },
            eMail: {
                title: "你的電郵地址",
                zw: "電郵地址",
            },
            subBtn: "送出",
        },
    },
    // 关于我们
    aboutUs: {
        img1: require("./assets/images/logo2.png"),
        title1: "關於李小龍會",
        des1: "李小龍會成立於 1995 年，由會長黃燿強先生成立，目的是繼續以李小龍的故鄉 — 香港為基地，透過所舉辦的活動及在互聯網上的聯系，讓全世界的李小龍迷有一個相互交流的機會及空間，從而結合大家的力量，致力推動、宏揚李小龍的電影藝術、武術、哲學思想，以讓年青的新一代，從李小龍傳奇的一生中學習到這種不朽的精神。",
        img2: require("./assets/images/prizm_logo2.png"),
        title2: `關於 <a href="https://www.prizmgroup.com/">PRIZM Group</a>`,
        des2: "Prizm Group 是一家集數碼營銷、 社交媒體內容營銷、大數據分析和電子商務為一體的數碼營銷公司。現在，Prizm Group 的辦公室遍布全球五個地區 。 Prizm 團隊掌握社交媒體及行銷科技 (Martech) 的發展趨勢，以前瞻的數碼技術及思維，為客戶提供全方位的解決方案。於 2022 年，Prizm Group 榮獲 Marketing Interactive 頒發的 Agency of The Year 年度大獎。",
        img3: require("./assets/images/payment_asia_logo.png"),
        title3: "場地贊助",
        title4: "傳媒查詢",
        des4: "",
        email: "info@bruceleeverse.com",
        iconList: [
            {
                icon: require("./assets/images/svg/icon_social_fb.svg"),
                url: "https://www.facebook.com/BruceLeeClub/",
            },
            {
                icon: require("./assets/images/svg/icon_social_ig.svg"),
                url: "https://www.Instagram.com/bruceleeverse/",
            },
            {
                icon: require("./assets/images/svg/icon_social_youtube.svg"),
                url: "https://www.youtube.com/channel/UC6SUzRu7vESQGdmL0f0QSEQ",
            },
        ],
    },
    // 顶部菜单
    menuList: ["展覽資訊", "故居VR體驗", "聯絡我們"],
    // menuList: ["展覽資訊", "故居VR體驗", "展覽精華", "聯絡我們"],
    // 提交提示
    submitTip: {
        fName: {
            tip: {
                kong: "必須填寫姓氏",
                geshi: "請輸入有效的姓氏",
            },
        },
        lName: {
            tip: {
                kong: "必須填寫名字",
                geshi: "請輸入有效的名字",
            },
        },
        country: {
            tip: {
                kong: "必須選擇所屬國家/地區",
                geshi: "請輸入有效的名字",
            },
        },
        eMail: {
            tip: {
                kong: "必須填寫電郵地址",
                geshi: "電郵地址格式不正確，請重新輸入",
            },
        },
    },
    cookieTxt: {
        tip: "我們透過使用Cookie以評估您在我們網站的使用情況，為您提供最佳的網站體驗。如果你繼續瀏覽本網站，即表示您接受我們使用Cookie來收集數據。",
        btnTxt: "我接受",
    },
    networkTip: {
        success: "已成功訂閱，多謝你的支持",
        btnTxt: "確定",
    },
    countryList: ["香港", "阿富汗", "奧蘭", "阿爾巴尼亞", "阿爾及利亞", "美屬薩摩亞", "安道爾", "安哥拉", "安圭拉", "南極洲", "安提瓜和巴布達", "阿根廷", "亞美尼亞", "阿魯巴", "澳大利亞", "奧地利", "阿塞拜疆", "巴林", "孟加拉", "巴巴多斯", "白俄羅斯", "比利時", "伯利茲", "貝寧", "百慕達", "不丹", "玻利維亞", "荷蘭加勒比區", "波黑", "博茨瓦納", "布韋島", "巴西", "英屬印度洋領地", "英屬維爾京群島", "汶萊", "保加利亞", "布基納法索", "布隆迪", "柬埔寨", "喀麥隆", "加拿大", "佛得角", "開曼群島", "中非", "乍得", "智利", "中國", "聖誕島", "科科斯（基林）群島", "哥倫比亞", "科摩羅", "庫克群島", "哥斯達黎加", "科特迪瓦", "克羅地亞", "古巴", "古拉索", "塞浦路斯", "捷克", "朝鮮民主主義人民共和國", "剛果民主共和國", "丹麥", "吉布提", "多米尼克", "多米尼加", "厄瓜多爾", "埃及", "薩爾瓦多", "英格蘭", "赤道幾內亞", "厄立特里亞", "愛沙尼亞", "斯威士蘭", "埃塞俄比亞", "福克蘭群島", "法羅群島", "密克羅尼西亞聯邦", "斐濟", "芬蘭", "法國", "法屬圭亞那", "法屬波利尼西亞", "法屬南部和南極領地", "加蓬", "格魯吉亞", "德國", "加納", "直布羅陀", "希臘", "格陵蘭", "格林納達", "瓜地洛普", "關島", "危地馬拉", "根西", "幾內亞", "幾內亞比紹", "圭亞那", "海地", "赫德島和麥克唐納群島", "洪都拉斯", "匈牙利", "冰島", "印度", "印尼", "伊朗", "伊拉克", "愛爾蘭", "萌島", "以色列", "意大利", "牙買加", "日本", "澤西", "約旦", "哈薩克", "肯雅", "基里巴斯", "科索沃", "科威特", "吉爾吉斯", "老撾", "拉脫維亞", "黎巴嫩", "萊索托", "利比里亞", "利比亞", "列支敦士登", "立陶宛", "盧森堡", "澳門", "馬達加斯加", "馬拉維", "馬來西亞", "馬爾代夫", "馬里", "馬爾他", "馬紹爾群島", "馬丁尼克", "毛里塔尼亞", "毛里裘斯", "馬約特", "墨西哥", "摩爾多瓦", "摩納哥", "蒙古", "黑山", "蒙特塞拉特", "摩洛哥", "莫桑比克", "緬甸", "納米比亞", "瑙魯", "尼泊爾", "荷蘭", "新喀里多尼亞", "新西蘭", "尼加拉瓜", "尼日爾", "尼日利亞", "紐埃", "諾福克島", "北馬其頓", "北愛爾蘭", "北馬利安納群島", "挪威", "阿曼", "巴基斯坦", "帕勞", "巴拿馬", "巴布亞新幾內亞", "巴拉圭", "秘魯", "菲律賓", "皮特凱恩群島", "波蘭", "葡萄牙", "波多黎各", "卡塔爾", "大韓民國", "剛果共和國", "留尼旺", "羅馬尼亞", "俄羅斯", "盧旺達", "聖巴瑟米", "聖赫勒拿、阿森松和特里斯坦-達庫尼亞", "聖吉斯納域斯", "聖盧西亞", "法屬聖馬丁", "聖皮埃與密克隆群島", "聖文森特和格林納丁斯", "薩摩亞", "聖馬力諾", "聖多美和普林西比", "沙特阿拉伯", "蘇格蘭", "塞內加爾", "塞爾維亞", "塞舌爾", "塞拉利昂", "新加坡", "荷屬聖馬丁", "斯洛伐克", "斯洛文尼亞", "所羅門群島", "索馬里", "南非", "南喬治亞和南桑威奇群島", "南蘇丹", "西班牙", "斯里蘭卡", "巴勒斯坦", "蘇丹", "蘇里南", "斯瓦爾巴和揚馬延", "瑞典", "瑞士", "敘利亞", "臺灣", "塔吉克", "坦桑尼亞", "泰國", "巴哈馬", "岡比亞", "東帝汶", "多哥", "托克勞", "湯加", "特立尼達和多巴哥", "突尼西亞", "土耳其", "土庫曼", "特克斯與凱科斯群島", "圖瓦盧", "烏干達", "烏克蘭", "阿聯酋", "英國", "美國本土外小島嶼", "美國", "美屬維爾京群島", "烏拉圭", "烏茲別克", "瓦努阿圖", "梵蒂岡", "委內瑞拉", "越南", "威爾斯", "瓦利斯和富圖那", "西撒哈拉", "也門", "贊比亞", "津巴布韋"],
    floatImg: require("./assets/images/icon_gift.svg"),
    banq: `<p>
    版權所有©2022 BRUCE LEE CLUB & PRIZM GROUP｜<a
      href="https://www.bruceleeclub.com/zh-tw/pages/terms-conditions"
      >網站條款及細則</a
    >
    ｜
    <a
      href="https://www.bruceleeclub.com/zh-tw/pages/privacy-policy"
      >私隱政策</a
    >
  </p>`,
    btnTxt: ["確認", "取消"],
};

let EN = {
    default: "EN",
    // 展览
    exhibition: {
        title: require("./assets/images/lee_title.svg"),
        // title:
        //     "Revival of the Memory:<br/><span>Bruce Lee's Home</span> in Metaverse",
        des: `
        <p>In 2019, Bruce Lee's old home in Hong Kong- No. 41, Cumberland Road - was demolished. Three years later, we are delighted to announce the commencement of "Revival of the Memory: Bruce Lee's Home in Metaverse".</p>
        <p>Bruce Lee Club joins hands with <a href="https://www.facebook.com/prizm.digital/">PRIZM Group</a>, together with three students from Shatin IVE, to recreate Bruce Lee's former home "Crane's Nest" with Web 3.0 technology in the metaverse. Lee's fans can visit his mansion in person in the metaverse and participate in all future events we host with other creators.</p>
        <p>The Hong Kong Polytechnic University School of Design provides content suggestions, and renowned computer graphics artist Shannon Ma is invited to be our technical consultant. The project is anticipated to be completed on the eve of the 50th anniversary of Bruce Lee's death.</p>
        `,
        detailList: {
            title: "Details of Exhibition",
            date: require("./assets/images/time.svg"),
            location: {
                title: "LOCATION",
                txt: "Shop D, G/F, 28 Russel Street, Causeway Bay"
            },
            actTime: {
                title: "TIME",
                timeList: [
                    { date: ["SUN", "THU"], time: ["11am", "8pm"] },
                    { date: ["FRI", "SAT"], time: ["11am", "9pm"] },
                ],
            },
            // list: [
            //     {
            //         icon: require("@/assets/images/svg/icon_location.svg"),
            //         title: "Location",
            //         txt: "Shop D, G/F, 28 Russel Street, Causeway Bay",
            //     },
            //     {
            //         icon: require("@/assets/images/svg/icon_date.svg"),
            //         title: "Date",
            //         txt: "August 6-14, 2022",
            //     },
            // ],
        },
        map: require("./assets/images/image_map _eng.png")
    },
    // VR体验
    VR: {
        // title: require("./assets/images/image_title_2.png"),
        title: "VR Experience of Bruce Lee's Old Home",
        des: "The 1:1 real scale replica takes you back to the 1970s version of No. 41 Cumberland Road, Kowloon Tong. Fans around the world will be able to walk through Bruce Lee's fascinating life via web 3.0 immersive experience.",
        bannerList: [
            {
                img: require("@/assets/images/pic1.png"),
                des: "Reconstruction of Bruce Lee's home in the Metaverse",
            },
            {
                img: require("@/assets/images/pic2.png"),
                des: "Immense research work was done to create a replica of the mansion with precise details",
            },
            {
                img: require("@/assets/images/pic3.png"),
                des: `The board of “Crane's Nest”, said to be written by renowned traditionalist painter Chang Dai-chien`,
            },
            {
                img: require("@/assets/images/pic6.png"),
                des: "(From left) Lee Chun Kit Owen, Yuen Ho Wa Andy, Li Chun Kit Jacky of IVE, Jeffrey Hau of PRIZM Group, Wong Yiu-Keung of Bruce Lee Club, Dr.Anthony Kong, Dr.Kenny Chow of PolyU, and lecturer Cheung Ming Yin Marvin of IVE",
            },
            {
                img: require("@/assets/images/pic5.png"),
                des: "Bird-eye view of Bruce Lee's former residence (1973)",
            },
            {
                img: require("@/assets/images/pic4.png"),
                des: "“Crane's Nest” has become a love hotel after the change of ownership",
            },

        ],
    },
    // 精华
    JH: {
        // title: require("./assets/images/image_title_3.png"),
        title: "展覽精華",
        des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
        bannerList: [
            {
                img: require("@/assets/images/banner2.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner1.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner2.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
            {
                img: require("@/assets/images/banner1.png"),
                des: "豫章故郡，洪都新府。星分翼轸，地接衡廬。襟三江而帶五湖，控蠻荊而引瓯越。物華天寶，龍光射牛鬥之墟;人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。台隍枕夷夏之交，賓主盡東南之美。",
            },
        ],
    },
    // 联络我们
    callUs: {
        // title: "Please leave your contact information low",
        des: `Register for more Bruce Lee collectibles<br />and VR information, 
        <br />Stay tuned for a sneak peek of BruceLeeVerse. 
        <br /><br />A full launch is on its way soon! 
        `,
        form: {
            name: {
                title: "Name",
                zw: ["Surname", "Name"],
            },
            country: {
                title: "Where are you from",
                zw: "Country/District",
            },
            eMail: {
                title: "Email",
                zw: "Email address",
            },
            subBtn: "Send out",
        },
    },
    // 关于我们
    aboutUs: {
        img1: require("./assets/images/logo2.png"),
        title1: "About Bruce Lee Club",
        des1: `In 1995, the Bruce Lee Club was established by Chairman W Wong Yiu-keung in Hong Kong, also known as the hometown of the legend. With a range of activities, we provide a platform for worldwide Bruce Lee fans to unite their voices. By promoting and paying utmost tribute to Bruce Lee's films, martial arts, and philosophy, we encourage the younger generations to admire the legend and live with his never-give-up spirit.`,
        img2: require("./assets/images/prizm_logo2.png"),
        title2: `About <a href="https://www.prizmgroup.com/">PRIZM Group</a>`,
        des2: "Prizm Group is a global agency with specialization in digital marketing, social media, big data, and eCommerce with 5 offices in Asia and Oceania. The group's expertise lies beyond a mere digital solution but synchronizing MarTech and Creativity to empower the formation of a seamless digital experience. In 2022, Prizm Group has crowned the prestige overall Agency of the Year hosted by Marketing Interactive.",
        img3: require("./assets/images/payment_asia_logo.png"),
        title3: "Venue sponsorship",
        title4: "Media Enquiry",
        des4: "",
        email: "info@bruceleeverse.com",
        iconList: [
            {
                icon: require("./assets/images/svg/icon_social_fb.svg"),
                url: "https://www.facebook.com/BruceLeeClub/",
            },
            {
                icon: require("./assets/images/svg/icon_social_ig.svg"),
                url: "https://www.Instagram.com/bruceleeverse/",
            },
            {
                icon: require("./assets/images/svg/icon_social_youtube.svg"),
                url: "https://www.youtube.com/channel/UC6SUzRu7vESQGdmL0f0QSEQ",
            },
        ],
    },
    // 顶部菜单
    menuList: ["Details of Exhibition", "VR Experience of Bruce Lee's Old Home", "Contact us"],
    // menuList: [
    //     "Details of Exhibition",
    //     "VR Experience of Bruce Lee's Old Home",
    //     "Exhibition essence",
    //     "Contact us",
    // ],
    // 提交提示
    submitTip: {
        fName: {
            tip: {
                kong: "Last name is required",
                geshi: "Please enter a valid last name",
            },
        },
        lName: {
            tip: {
                kong: "Name is required",
                geshi: "Please enter a valid name",
            },
        },
        country: {
            tip: {
                kong: "Country/District must be selected",
                geshi: "Please enter a valid region",
            },
        },
        eMail: {
            tip: {
                kong: "Email address is required",
                geshi: "Email address format is incorrect, please re-enter",
            },
        },
    },
    cookieTxt: {
        tip: "We use cookies to give you the best possible experience on our website. By continuing to browse this site, you give consent for cookies to be used.",
        btnTxt: "I accept",
    },
    networkTip: {
        success: "You have successfully subscribed. Thank you for your support.",
        btnTxt: "Confirm",
    },
    countryList: ["Hong Kong", "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Cook Islands", "Costa Rica", "Côte d'Ivoire", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Democratic People's Republic of Korea", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "England", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands", "Faroe Islands", "Federated States of Micronesia", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gabon", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "Northern Ireland", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of Korea", "Republic of the Congo", "Réunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "São Tomé and Príncipe", "Saudi Arabia", "Scotland", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "State of Palestine", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "The Bahamas", "The Gambia", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom of Great Britain and Northern Ireland", "United States Minor Outlying Islands", "United States of America", "United States Virgin Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Wales", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"],
    floatImg: require("./assets/images/icon_gift_eng.svg"),
    banq: `<p>
    Copyright©2022 BRUCE LEE CLUB & PRIZM GROUP｜<a
      href="https://www.bruceleeclub.com/zh-tw/pages/terms-conditions"
      >Terms and Conditions</a
    >
    ｜
    <a
      href="https://www.bruceleeclub.com/zh-tw/pages/privacy-policy"
      >Privacy Policy</a>
  </p>`,
    btnTxt: ["confirm", "cancel"],
};

export default {
    CN,
    EN,
};
